import { FaFacebookMessenger, FaSlack, FaWhatsapp } from 'react-icons/fa';
import { useAppInfo } from '../../../helpers/hooks/common-hook';
import config from '../../../config';
import { ChannelLayout, SettingsCard, CopyField, CredentialForm, useChannelStatus } from '../_components/channel-settings';

const channels = {
  facebook: { title: 'Facebook Messenger', icon: FaFacebookMessenger, description: 'Bring your agent to conversations on your Facebook Page.' },
  whatsapp: { title: 'WhatsApp', icon: FaWhatsapp, description: 'Connect your agent to your WhatsApp business messaging channel.' },
  slack: { title: 'Slack', icon: FaSlack, description: 'Make your agent available to your team in Slack.' },
};

function ChannelSettings({ appId, channel, callbackUrlLabel, verifyTokenEnable, verifyTokenLabel, accessKeyLabel }) {
  const status = useChannelStatus(appId, channel);
  const details = channels[channel];
  return <ChannelLayout {...details} {...status}>
    <div className="grid items-start gap-6 lg:grid-cols-2">
      <SettingsCard title="Webhook settings" description="Copy these values into your channel’s webhook configuration.">
        <CopyField id={`${channel}-callback`} label={callbackUrlLabel} value={`${config.API_BASE_URL}/apps/${appId}/channels/${channel}/webhook`} />
        {verifyTokenEnable && <CopyField id={`${channel}-verify`} label={verifyTokenLabel} value={appId} />}
        <p className="rounded-xl bg-gray-50 p-4 text-xs leading-6 text-gray-500">These values identify this application. Use them when configuring events for {details.title}.</p>
      </SettingsCard>
      <SettingsCard title="Authentication" description={`Manage the credentials used to send messages through ${details.title}.`}>
        <CredentialForm appId={appId} channel={channel} configured={status.configured} fields={[{ name: 'accessKey', label: accessKeyLabel, secret: true }]} onSaved={() => status.setConfigured(true)} />
      </SettingsCard>
    </div>
  </ChannelLayout>;
}

export default function IntegrationChannelPage({ channel, callbackUrlLabel = 'Callback URL', verifyTokenEnable = true, verifyTokenLabel = 'Verify token', accessKeyLabel = 'Access token' }) {
  const { appId } = useAppInfo();
  return <ChannelSettings key={`${appId}:${channel}`} {...{ appId, channel, callbackUrlLabel, verifyTokenEnable, verifyTokenLabel, accessKeyLabel }} />;
}
